export const SOLO_UPLOAD_FILES_INVALIDATE = "SOLO_UPLOAD_FILES_INVALIDATE";
export const SOLO_UPLOAD_FILES_FETCH_REQUEST =
  "SOLO_UPLOAD_FILES_FETCH_REQUEST";
export const SOLO_UPLOAD_FILES_FETCH_SUCCESS =
  "SOLO_UPLOAD_FILES_FETCH_SUCCESS";
export const SOLO_UPLOAD_FILES_FETCH_ERROR = "SOLO_UPLOAD_FILES_FETCH_ERROR";
export const SOLO_UPLOAD_FILE_REQUEST = "SOLO_UPLOAD_FILE_REQUEST";
export const SOLO_UPLOAD_FILE_SUCCESS = "SOLO_UPLOAD_FILE_SUCCESS";
export const SOLO_UPLOAD_FILE_ERROR = "SOLO_UPLOAD_FILE_ERROR";
export const SIGN_OUT_COMPLETE = "SIGN_OUT_COMPLETE";
export { WORKAREA_SET } from "features/workarea/constants";
export { ORGANIZATION_SET } from "features/organization/constants";
